import { useContext, useState } from "react";
import { AuthContext } from "../../context/auth-context";
import Papa from "papaparse";
import LoadingSpinnerWrapper from "../UI/LoadingSpinnerWrapper";
import { uploadCharging } from "../../api/add";
import { DataContext } from "../../context/data-context";

export default function AddCharging() {
  const { user } = useContext(AuthContext);
  const { fetchCharging } = useContext(DataContext);
  const [loading, setLoading] = useState(false);
  const [ignored, setIgnored] = useState([]);

  const submitHandler = (e) => {
    setLoading(true);
    e.preventDefault();

    // Read file and set data
    const file = e.target.file.files[0];
    const reader = new FileReader();
    reader.onload = async ({ target }) => {
      const csv = Papa.parse(target.result, { header: true });
      const parsedData = csv?.data;
      uploadChargingHandler(parsedData.reverse());
    };
    reader.readAsText(file);
    setLoading(false);
  };

  const uploadChargingHandler = async (data) => {
    try {
      setLoading(true);
      // Split Data in chunks of 100
      const chunks = [];
      for (let i = 0; i < data.length; i += 100) {
        chunks.push(data.slice(i, i + 100));
      }

      // Create array for ignored entries
      const ignored = [];

      // Upload each chunk
      Promise.all(
        chunks.map(async (chunk) => {
          const res = await uploadCharging(user, chunk);
          ignored.push(...res);
        })
      ).then(() => {
        setIgnored(ignored);
        fetchCharging(() =>  setLoading(false));
      });

    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  if (loading)
    return (
      <div className="w-full h-full p-8 overflow-scroll rounded-xl bg-stone-900">
        <LoadingSpinnerWrapper />
      </div>
    );

  return (
    <div className="container">
      <div className="grid gap-8">
        <div className="grid gap-2">
          <p className="hidden text-lg font-semibold text-white md:block">
            Add EV Charging
          </p>
          <hr className="hr" />
          <p className="text-sm text-stone-400">
            Download the csv file from the Tesla App (Profile &#62; Account
            &#62; Charging &#62; History) and upload the file here. Older
            records and duplicates are automatically ignored.
          </p>
        </div>

        <form onSubmit={submitHandler} className="grid gap-6">
          <div className="grid gap-4">
            <label className="form-label">Upload CSV:</label>
            <input type="file" name="file" className="form-input" required />
          </div>
          <button type="submit" className="btn-primary md:w-32">
            Submit
          </button>
        </form>

        {ignored.length > 0 && (
          <div className="grid gap-4">
            <p>Charging Ignored: {ignored.length}</p>
            <div className="grid gap-4 h-[320px] overflow-scroll">
              {ignored.map((toll, index) => (
                <></>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
